import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { FETCH_LOCATION_SET_LOCATIONS } from '../../../constants/index';
import { EMPTY_OBJECT, isEmptyObject } from '../../../core/util/object';
import { setEmptyLocation } from '../../../actions/location';
import { DataLock } from '../../../core/util/dataLock';
import useSelectGetLocationId from './useSelectGetLocationId';
import useSelectFetchAccountAppointments from './useSelectFetchAccountAppointments';
import { isEmptyArray } from '../../../core/util/array';
import { useSolvSelector } from '~/reducers';

const dataLock = new DataLock('');

export default (userProfileId: any) => {
  const dispatch = useDispatch();
  const locationId = useSelectGetLocationId(userProfileId);
  const { pastAppointments, upcomingAppointments } = useSelectFetchAccountAppointments(
    userProfileId
  );
  const mostRecentPastLocation = useSelector((state: any) => state.locations.results[locationId]);

  const isLoading = useSolvSelector(
    (state) => state.account.accountSummaryLoading || state.account.accountAppointmentsFetching
  );

  useEffect(() => {
    if ((!isLoading && dataLock.isSame(userProfileId)) || !isEmptyObject(mostRecentPastLocation)) {
      return;
    }
    dataLock.updateValue(userProfileId);

    if (locationId && !isEmptyArray(upcomingAppointments) && !isEmptyArray(pastAppointments))
      dispatch({
        type: FETCH_LOCATION_SET_LOCATIONS,
        locationId,
      });
    else {
      dispatch(setEmptyLocation());
    }
  }, [
    dispatch,
    locationId,
    mostRecentPastLocation,
    pastAppointments,
    upcomingAppointments,
    userProfileId,
    isLoading,
  ]);

  return isEmptyObject(mostRecentPastLocation) ? EMPTY_OBJECT : mostRecentPastLocation;
};
